export default "__VITE_ASSET__SgiFk0QE__"